<script setup lang="ts">
import { Tooltip } from 'catalyst-vue'
import type { ComicStatus } from '../../lib/comic-status'

/**
 * 一顆狀態燈。
 *
 * 刻意只有顏色，沒有圖示：圖示在 22px 的圓裡本來就看不清楚，而且會讓這顆點看起來
 * 像一顆可以按的按鈕。它是燈號，說明全部交給游標停留時出現的 Tooltip。
 */
withDefaults(defineProps<{ status: ComicStatus; size?: 'md' | 'sm' }>(), { size: 'md' })
</script>

<template>
  <span class="comic-status-dot" :data-tone="status.tone" :data-size="size">
    <Tooltip :text="status.label">
      <!--
        不給 tabindex：一頁有幾百顆燈，每顆都變成停留點會讓鍵盤逐張翻書變得很難走。
        role=img 加 aria-label 已經讓輔助技術在讀到這張卡片時唸出同一句話。
      -->
      <span class="comic-status-dot-face" role="img" :aria-label="status.label" />
    </Tooltip>
  </span>
</template>
